import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { finalize } from 'rxjs/operators';
import { TeamService } from '../../_core/services/team.service';
import { Team } from '../../_shared/models/team.model';
import { User } from '../../_shared/models/user.model';
import { AuthService } from '../../auth/auth.service';

@Component({
  standalone: false,
    selector: 'app-select-team',
    templateUrl: './select-team.component.html',
    styleUrls: ['./select-team.component.scss'],
})
export class SelectTeamComponent implements OnInit {

    @Input() teams: Team[];
    @Input() leagueId: string;
    isLoading: boolean;
    isOwner: boolean;
    authUser: User;

    constructor(
        private modalController: ModalController,
        private teamService: TeamService,
        private authService: AuthService
    ) { }

    async ngOnInit() {
        if (!this.teams) {
            this.getTeams();
        }
        this.authUser = await this.authService.getAuthUser();
    }

    getTeams() {
        this.isLoading = true;
        this.teamService
            .getMyTeams()
            .pipe(finalize(() => this.isLoading = false))
            .subscribe(
                res => {
                    this.teams = res.data;
                    // filter the team which is owned by the user or the user is an official of the team
                    this.teams = this.teams.filter(team => team.owners?.some((owner:any) => owner === this.authUser._id) || team.officials?.some((official:any) => official === this.authUser._id));
                },
                err => this.close()
            );
    }

    selectTeam(index) {
        const team = this.teams[index];
        this.modalController.dismiss(team);
    }

    close() {
        this.modalController.dismiss();
    }

}
